import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "mainText" }



export default /*@__PURE__*/_defineComponent({
  __name: 'MiniDialog',
  props: [`values`],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper", {error:_ctx.values.status===`Error`}])
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.values.status), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.values.text), 1)
  ], 2))
}
}

})